import React from "react";
import { Typography, Container } from "@mui/material";
import { Link } from "react-router-dom";

const NavbarComponent = () => {
  const role = localStorage.getItem("type");

  return (
    <div
      style={{
        backgroundColor: "#fff",
        padding: "16px 0",
        borderBottom: "1px solid #e0e0e0",
      }}
    >
      <Container maxWidth="lg" style={{ display: "flex" }}>
        <Typography
          variant="h5"
          component={Link}
          to={`/${role}/docvault`}
          sx={{
            textDecoration: "none",
            color: "black",
            fontWeight: 600,
          }}
        >
          Doc Vault
        </Typography>
      </Container>
    </div>
  );
};

export default NavbarComponent;
